import { Select, MenuItem } from "@mui/material";
import React from "react";

import { ReactComponent as ArrowDown } from "assets/arrow-down.svg";

import styles from "./WorkspacesPage.module.scss";

export enum ProjectSortingOptions {
  RECENT_ACTIVITY = "RECENT_ACTIVITY",
  CREATED_DATE = "CREATED_DATE",
}

interface ProjectSortingOptionsDropdownProps {
  projectsOrder: ProjectSortingOptions;
  setProjectsOrder: React.Dispatch<React.SetStateAction<ProjectSortingOptions>>;
}

const ProjectSortingOptionsDropdown: React.FC<
  ProjectSortingOptionsDropdownProps
> = ({ projectsOrder, setProjectsOrder }) => {
  return (
    <div className={styles.projectSortingOptions}>
      <h5>Sort by:</h5>
      <Select
        className={styles.sortingOptionsDropdown}
        value={projectsOrder}
        onChange={(e) => {
          setProjectsOrder(e.target.value as ProjectSortingOptions);
        }}
        IconComponent={ArrowDown as React.ElementType}
        MenuProps={{
          slotProps: {
            paper: {
              sx: {
                marginTop: "4px",
                backgroundColor: "#111113",
                borderRadius: "7px",
                border: "1px solid #CCCCDC1F",
                padding: "0px 8px",
                boxShadow: "0px 8px 24px 0px #010409",
                color: "white",
              },
            },
          },
        }}
        sx={{
          display: "flex",
          gap: "8px",
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: "4px",
          },
          "& .MuiSelect-icon": {
            position: "relative",
            alignSelf: "center",
            top: "2px",
          },
        }}
      >
        <MenuItem
          className={styles.menuItem}
          value={ProjectSortingOptions.RECENT_ACTIVITY}
          sx={{
            marginBottom: "4px",
            "&.Mui-selected": {
              background: "#222226 !important",
              borderRadius: "4px",
            },
          }}
        >
          Last modified
        </MenuItem>
        <MenuItem
          className={styles.menuItem}
          value={ProjectSortingOptions.CREATED_DATE}
          sx={{
            "&.Mui-selected": {
              background: "#222226 !important",
              borderRadius: "4px",
            },
          }}
        >
          Created date
        </MenuItem>
      </Select>
    </div>
  );
};

export default ProjectSortingOptionsDropdown;
